import { IMAGE_EFFECTS } from "../../lib/imageEffects";
import { COLOR_SWATCHES } from "../../lib/constants";
import { Slider } from "../ui/slider";

export default function ImageEffects({ el, onUpdate, onStart }) {
  const current = el.imgEffect || "none";
  const meta = IMAGE_EFFECTS.find((e) => e.id === current) || {};
  const u = onUpdate;

  return (
    <div data-testid="image-effects-section">
      <p className="text-[10px] uppercase tracking-[0.2em] text-zinc-400 font-semibold mb-3">Image effects</p>
      <div className="grid grid-cols-3 gap-2 mb-4">
        {IMAGE_EFFECTS.map((e) => (
          <button
            key={e.id}
            onClick={() => { onStart(); u({ imgEffect: e.id }); }}
            data-testid={`img-effect-${e.id}`}
            className={`rounded-lg border p-2 flex items-center justify-center h-12 text-[11px] font-medium text-center transition-all ${current === e.id ? "border-blue-500 bg-blue-600/15 text-white" : "border-white/10 bg-[#0E0E0E] text-zinc-300 hover:border-white/25"}`}
          >
            {e.label}
          </button>
        ))}
      </div>

      {meta.color && (
        <div className="mb-4">
          <p className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-semibold mb-2">Effect color</p>
          <div className="flex items-center gap-2">
            <label className="relative h-8 w-8 rounded-lg border border-white/15 overflow-hidden cursor-pointer shrink-0" style={{ background: el.imgEffectColor || "#ffffff" }}>
              <input type="color" value={el.imgEffectColor || "#ffffff"} onMouseDown={onStart} onChange={(e) => u({ imgEffectColor: e.target.value })} className="absolute inset-0 opacity-0 cursor-pointer" data-testid="img-effect-color" />
            </label>
            <div className="grid grid-cols-8 gap-1.5 flex-1">
              {COLOR_SWATCHES.slice(0, 16).map((c) => (
                <button key={c} onClick={() => { onStart(); u({ imgEffectColor: c }); }} className="h-4 w-4 rounded border border-white/15 hover:scale-110 transition-transform" style={{ background: c }} />
              ))}
            </div>
          </div>
        </div>
      )}

      {meta.size && (
        <div className="mb-2">
          <p className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-semibold mb-2">Size / Intensity</p>
          <Slider value={[el.imgEffectSize ?? 50]} min={0} max={100} step={1} onPointerDown={onStart} onValueChange={(v) => u({ imgEffectSize: v[0] })} data-testid="img-effect-size" />
        </div>
      )}
    </div>
  );
}
